module.exports = __webpack_public_path__ + "img/bg3.02133d92.jpg";